module.exports = __webpack_public_path__ + "static/media/solmonte_gonzalez_adams.3e506652.gif";